export default "__VITE_ASSET__B5zT3lIZ__"